<template>
  <div>
    <div>
      <div
        class="card"
        :id="'popover-target-' + `${tema.modalidad == 'Virtual' ? tema.cve_tema : tema.cve_curso }`"
      >
        <div class="image-container">
          <img
            :src="tema.imagen_url"
            class="card-img-top"
            alt="tema imagen"
            @error="tema.imagen_url = '/static/img/temas/ejemplo_tema_1.jpg'"
          />
          <div class="overlay-text">
            <p v-if="tema.modalidad === 'Presencial'">
              {{tema.modalidad}} - {{ tema.fecha_curso | moment("D MMMM YYYY") }}
            </p>
            <p v-else-if="tema.modalidad === 'Mixto'">
              Streaming - {{ tema.fecha_curso | moment("D MMMM YYYY") }}
            </p>
            <p v-else>
              {{ tema.modalidad }}
            </p>
          </div>
        </div>
        <div class="card-body" style="height: 250px;">
          <h4 class="card-title font-bold">
            <strong>{{ tema.nombre_tema }}</strong>
          </h4>
          <p class="card-text">
            {{ tema.descripcion_tema }}
          </p>

          <div class="mt">
            <p>
              <div class="rating-container">
                <star-rating
                  read-only="true"
                  :rating="tema.rating"
                  :show-rating="false"
                  star-size="25"
                  border-color="#FF0"
                  increment="0.5"
                />
                <span class="text-muted ml-2">{{ tema.rating }}/5</span>
              </div>
            </p>
            <span class="precio-container">
              $ {{ !tema.precio ? 0 : tema.precio }} MXN
            </span>
          </div>
        </div>

        <div class="card-footer">
          <span></span>
          <span>{{ +tema.horas > 1 ? `${tema.horas} ${$t('page.general.horas')}` : `${tema.horas} ${$t('page.general.hora')}` }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StarRating from 'vue-star-rating'
export default {
  components: {
    StarRating
  },
  props: ['tema'],
  data() {
    return {
      temaSelected: {},
      precioTotal: 0,
    };
  },
  methods: {
    abrirModal(modalName) {
      this.$emit('modal-opened', this.tema);
    },
    irAShoppingCart() {
      this.$router.push({
        name: "Shopping_Cart",
        params: {
          items: [
            this.tema.temas[0],
            this.tema.temas[1],
          ]
        }
      });
    },
  },
  created() {
  },
};
</script>

<style scoped>
.card-body {
  padding: 1rem;
  cursor: pointer;
}
.image-container {
  width: 100%;
  position: relative;
  cursor: pointer;
}
.image-container {
  img {
    width: 100%;
  }
}

.card-img-top {
  height: auto;
  height: 12rem;
  width: 100%;
  object-fit: cover;
}
.card {
  width: 90%;
}

.overlay-text {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  text-align: center;
  padding: 5px;
  height: 30px;
}
.rating-container {
  display: flex;
  align-items: baseline;
}
.rating-container span {
  font-size: 15px;
}
.precio-container {
  font-size: 1.5rem;
  font-weight: 700;
  text-transform: none;
}
.card-footer {
  display: flex;
  justify-content: space-between;
  background-color: white;
  cursor: pointer;
}
/* .card-text {
  height: 4rem;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  text-overflow: ellipsis;
} */
.no-image {
  height: 12rem;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f0f0f0;
  text-transform: none;
  font-weight: bold;
}
.card-body {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 250px;
}

.card-title,
.card-text {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.card-text {
  /* Si deseas que la descripción se ajuste al tamaño de 2 líneas */
  -webkit-line-clamp: 2;
}

.mt {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

.card-footer {
  margin-top: auto; /* Asegura que el pie de la carta esté al final */
}


</style>



// WEBPACK FOOTER //
// src/components/AppLms/e-commerce/curso_card_ecommerce.vue